module.exports = __webpack_public_path__ + "img/Angiogenesis-GBM_SPATA.4337687f.png";